import {
  createClient,
  type FunctionInvokeOptions,
} from '@supabase/supabase-js';
import { Monitoring } from '../lib/monitoring';

const {
  VITE_SUPABASE_PROJECT_URL: PROJECT_URL,
  VITE_SUPABASE_ANON_KEY: PROJECT_KEY,
} = import.meta.env;

const supabaseClient = createClient(PROJECT_URL, PROJECT_KEY);

const SLOW_REQUEST_THRESHOLD_MS = 20000;

let activeOrganizationId: string | undefined;

export const setApiOrganizationId = (organizationId: string | undefined) => {
  activeOrganizationId = organizationId;
};

export const baseApi = {
  auth: supabaseClient.auth,
  from: supabaseClient.from.bind(supabaseClient),
  functions: {
    invoke: async <T>(
      functionName: string,
      options?: FunctionInvokeOptions,
    ) => {
      const headers: Record<string, string> = {
        ...options?.headers,
      };

      if (activeOrganizationId) {
        headers['x-organization-id'] = activeOrganizationId;
      }

      const start = performance.now();
      const result = await supabaseClient.functions.invoke<T>(functionName, {
        ...options,
        headers,
      });
      const duration = Math.round(performance.now() - start);

      if (result.error) {
        Monitoring.captureError(result.error);
      } else if (duration > SLOW_REQUEST_THRESHOLD_MS) {
        Monitoring.captureSlowRequest(functionName, duration);
      }

      return result;
    },
  },
};
